import axios from "axios";

const Api = axios.create({
    baseURL: window.APP_API_ENDPOINT
});

export default Api;